<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">New User Promo</h5>
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <b-dropdown
            :disabled="selected.length === 0"
            id="dropdown-1"
            text="Action"
            :variant="selected.length === 0 ? 'primary':'warning'"
            class="m-md-2"
          >
            <b-dropdown-item @click="submitStatus('publish')" href="#">Publish</b-dropdown-item>
            <b-dropdown-item @click="submitStatus('archive')" href="#">Archive</b-dropdown-item>
          </b-dropdown>
          <router-link :to="{name: 'createnewUserPromo'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        show-empty
        hover
        ref="selectableTable"
        selectable
        :select-mode="selectMode"
        @row-selected="onRowSelected"
        responsive="sm"
        :items="getInfo"
        :fields="key"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
        filter-debounce="500"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:head(selected)="data">
          <span class="text-info">
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll"
            ></b-form-checkbox>
          </span>
        </template>
        <template v-slot:cell(created_at_date_only)="{ value, item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>
          by {{item.created_by_username}}
        </template>
        <template v-slot:cell(updated_at_date_only)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{item.updated_at_date_only}}</p>
            by {{item.updated_by_username}}
          </div>
        </template>
        <template v-slot:cell(selected)="{ rowSelected, item, index }">
          <template v-if="rowSelected">
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_true"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_false"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template v-slot:cell(status)="row">
          <p class="text-success" v-if="row.value == 'publish'">Publish</p>
          <p class="text-warning" v-else-if="row.value == 'archive'">Archive</p>
        </template>
        <template v-slot:cell(image)="row">
          <b-img :src="row.value" width="75px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(publish_date)="{ value, item }">
          <div>
            {{item.publish_date_start === "" ? "Empty":item.publish_date_start.substring(0,10)}}&nbsp;
            <i
              class="fas fa-arrow-right"
            ></i>
            &nbsp;{{item.publish_date_end === "" ? "Empty":item.publish_date_end.substring(0,10)}}
          </div>
        </template>
        <template v-slot:cell(title.id)="row">
          <div v-html="row.value.substring(0,20)"></div>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{name: 'editnewUserPromo', params: {id: item.id}}"
            class="text-dark"
          >
            <img src="@/assets/ic-edit.svg" class="mr-2" alt />
          </router-link>
          <b-link
            v-b-tooltip.hover
            title="View Detail"
            @click="modalShow = !modalShow"
            class="text-dark"
          >
            <img @click="getDetail(item.id)" src="@/assets/ic-view-detail.svg" alt />
          </b-link>
          <!-- <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="del(item.id)">
            <img src="@/assets/rectangle.svg" alt />
          </b-link>-->
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{rows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal v-model="modalShow" size="xl" ok-only hide-header>
      <b-row>
        <b-col>
          <h5 class="font-weight-bold">Preview</h5>
        </b-col>
        <b-col class="text-right">
          <i class="fas fa-times" @click="modalShow = !modalShow" style="cursor: pointer;"></i>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="4">
          <img v-if="detail.image" width="100%" :src="detail.image" />
        </b-col>
        <b-col>
          <b-row>
            <b-col md="12" class="font-weight-bold">Title:</b-col>
            <b-col md="4" class="font-weight-bold">In Bahasa</b-col>
            <b-col md="8">{{modalShow ? detail.title.id:''}}</b-col>
            <b-col md="4" class="font-weight-bold">In English</b-col>
            <b-col md="8">{{modalShow ? detail.title.en:''}}</b-col>
            <br />
            <b-col md="12" class="font-weight-bold">Content:</b-col>
            <b-col md="4" class="font-weight-bold">In Bahasa</b-col>
            <b-col md="8" v-html="modalShow ? detail.content.id:''"></b-col>
            <b-col md="4" class="font-weight-bold">In English</b-col>
            <b-col md="8" v-html="modalShow ? detail.content.en:''"></b-col>
            <b-col md="4" class="font-weight-bold">Promo Code</b-col>
            <b-col md="8">{{modalShow ? detail.promo_code:''}}</b-col>
            <br />
            <br />
            <b-col md="6" class="font-weight-bold">Product Detail:</b-col>
            <b-col md="6" class="font-weight-bold">
              <b-link
                class="text-primary"
                @click="product_detail = !product_detail"
              >{{product_detail ? 'Minimize':'See Detail'}}</b-link>
            </b-col>
            <b-col md="12" v-show="product_detail">
              <b-row>
                <b-col md="4" class="font-weight-bold">Product type</b-col>
                <b-col
                  class="text-capitalize"
                  md="8"
                >{{modalShow ? detail.product_master.type.replace("_", " "):''}}</b-col>
                <b-col md="4" class="font-weight-bold">Product Name</b-col>
                <b-col md="8">{{modalShow ? detail.product_master.name:''}}</b-col>
                <b-col md="4" class="font-weight-bold">Product Category</b-col>
                <b-col md="8">{{modalShow ? detail.product_master.category.name.id:''}}</b-col>
                <b-col md="4" class="font-weight-bold">Product Dimension</b-col>
                <b-col
                  md="8"
                >{{modalShow ? detail.product_master.dimension_height:''}}x{{modalShow ? detail.product_master.dimension_width:''}}x{{modalShow ? detail.product_master.dimension_length:''}}</b-col>
                <b-col md="4" class="font-weight-bold">Item(s) fit to:</b-col>
                <b-col md="8">
                  <b-row>
                    <b-col class="text-left">Small (S)</b-col>
                    <b-col>
                      <b-form-input
                        size="sm"
                        type="number"
                        readonly="readonly"
                        :value="modalShow ? detail.product_master.fit_to.small_minimum:''"
                        placeholder="Min"
                      ></b-form-input>
                    </b-col>
                    <p class="pt-2 mb-0">to</p>
                    <b-col>
                      <b-form-input
                        size="sm"
                        type="number"
                        readonly="readonly"
                        :value="modalShow ? detail.product_master.fit_to.small_maximum:''"
                        placeholder="Max"
                      ></b-form-input>
                    </b-col>
                    <p class="pt-2 mb-0">Item</p>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col class="text-left">Medium (M)</b-col>
                    <b-col>
                      <b-form-input
                        size="sm"
                        type="number"
                        readonly="readonly"
                        :value="modalShow ? detail.product_master.fit_to.medium_minimum:''"
                        placeholder="Min"
                      ></b-form-input>
                    </b-col>
                    <p class="pt-2 mb-0">to</p>
                    <b-col>
                      <b-form-input
                        size="sm"
                        type="number"
                        readonly="readonly"
                        :value="modalShow ? detail.product_master.fit_to.medium_maximum:''"
                        placeholder="Max"
                      ></b-form-input>
                    </b-col>
                    <p class="pt-2 mb-0">Item</p>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col class="text-left">Large (L)</b-col>
                    <b-col>
                      <b-form-input
                        size="sm"
                        type="number"
                        readonly="readonly"
                        :value="modalShow ? detail.product_master.fit_to.large_minimum:''"
                        placeholder="Min"
                      ></b-form-input>
                    </b-col>
                    <p class="pt-2 mb-0">to</p>
                    <b-col>
                      <b-form-input
                        size="sm"
                        type="number"
                        readonly="readonly"
                        :value="modalShow ? detail.product_master.fit_to.large_maximum:''"
                        placeholder="Max"
                      ></b-form-input>
                    </b-col>
                    <p class="pt-2 mb-0">Item</p>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col class="text-left">Custom (C)</b-col>
                    <b-col>
                      <b-form-input
                        size="sm"
                        type="number"
                        readonly="readonly"
                        :value="modalShow ? detail.product_master.fit_to.custom_minimum:''"
                        placeholder="Min"
                      ></b-form-input>
                    </b-col>
                    <p class="pt-2 mb-0">to</p>
                    <b-col>
                      <b-form-input
                        size="sm"
                        type="number"
                        readonly="readonly"
                        :value="modalShow ? detail.product_master.fit_to.custom_maximum:''"
                        placeholder="Max"
                      ></b-form-input>
                    </b-col>
                    <p class="pt-2 mb-0">Item</p>
                  </b-row>
                </b-col>
                <b-col md="4" class="font-weight-bold">Product Normal Price</b-col>
                <b-col md="8">{{modalShow ? detail.product_master.normal_price:''}}</b-col>
                <b-col md="4" class="font-weight-bold">Product Status:</b-col>
                <b-col md="8">
                  <label
                    v-for="data in modalShow ? detail.product_master.product_status:''"
                    :key="data"
                    class="text-capitalize m-0"
                  >
                    <label
                      class="mb-0 text-capitalize"
                      v-show="data.is_selected"
                    >{{data.name + ','}}</label>
                  </label>
                </b-col>
                <b-col md="4" class="font-weight-bold">Quota per day per user:</b-col>
                <b-col md="8">{{modalShow ? detail.product_master.quota_per_day:''}}</b-col>
                <b-col md="4" class="font-weight-bold">Sender Name / Contact:</b-col>
                <b-col
                  md="8"
                >{{modalShow ? detail.product_master.sender_name:''}}/{{modalShow ? detail.product_master.sender_phone_number:''}}</b-col>
                <b-col
                  md="4"
                  class="font-weight-bold"
                  v-if="modalShow && detail.product_master.type == 'pre_order'"
                >Preferred pickup slot / day:</b-col>
                <b-col md="8" v-if="modalShow && detail.product_master.type == 'pre_order'">
                  {{modalShow && detail.product_master.type == 'pre_order' ? detail.product_master.pre_order.preferred_pickup.display_name:''}}&nbsp; /
                  <label
                    v-for="data in modalShow && detail.product_master.type == 'pre_order' ? detail.product_master.pre_order.preferred_days:''"
                    :key="data"
                  >
                    <label class="mb-0 text-capitalize">{{data + ','}}</label>
                  </label>
                </b-col>
                <b-col
                  v-if="modalShow && detail.product_master.type == 'pre_order'"
                  md="4"
                  class="font-weight-bold"
                >Stock:</b-col>
                <b-col
                  v-if="modalShow && detail.product_master.type == 'pre_order'"
                  md="8"
                  class="mb-3"
                >{{modalShow && detail.product_master.type == 'pre_order' ? detail.product_master.pre_order.stock:''}}</b-col>
                <b-col
                  v-if="modalShow && detail.product_master.type == 'stock_point'"
                  md="4"
                  class="font-weight-bold"
                >PH / Stock:</b-col>
                <b-col
                  class="mb-4"
                  v-if="modalShow && detail.product_master.type == 'stock_point'"
                  md="8"
                >
                  <b-row
                    v-for="(input , k) in modalShow && detail.product_master.type == 'stock_point' ? detail.product_master.stock_point:''"
                    :key="k"
                  >
                    <b-col md="4">{{'PH ' + input.warehouse.name}}</b-col>
                    <b-col md="1">/</b-col>
                    <b-col class="text-left">{{input.stock}} pcs</b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
            <br />
            <br />
            <b-col md="4" class="font-weight-bold">Discount Type</b-col>
            <b-col md="8">{{modalShow ? detail.discount_type.name:''}}</b-col>
            <b-col md="4" class="font-weight-bold">Discount Value</b-col>
            <b-col md="8">{{modalShow ? detail.discount_value:''}}</b-col>
            <b-col md="4" class="font-weight-bold">Quantity Product/promo</b-col>
            <b-col md="8">{{modalShow ? detail.qty_product_per_promo:''}}</b-col>
            <b-col md="4" class="font-weight-bold">Quota Promo/user</b-col>
            <b-col md="8">{{modalShow ? detail.quota_promo_per_user:''}}</b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      errored: false,
      selectMode: "multi",
      selected: [],
      modalShow: false,
      allSelected: false,
      indeterminate: false,
      items: [],
      detail: [],
      key: [
        {
          key: "selected",
          class: "text-center"
        },
        {
          key: "created_at_date_only",
          label: "Created",
          sortable: true,
          class: "text-center"
        },
        {
          key: "promo_code",
          label: "New User Promo Code",
          sortable: true,
          class: "text-center"
        },
        {
          key: "product_masters.name",
          label: "Product",
          sortable: true,
          class: "text-center"
        },
        {
          key: "qty_product_per_promo",
          label: "Quota Promo",
          sortable: true,
          class: "text-center"
        },

        {
          key: "publish_date",
          label: "Promo Period",
          sortable: true,
          class: "text-center"
        },
        {
          key: "updated_at_date_only",
          label: "Updated",
          sortable: true,
          class: "text-left"
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-center"
        },
        { key: "action", label: "Action", class: "text-center" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      product_detail: false,
      sortDirection: "asc",
      filter: "",
      customerShow: false,
      selected_field_true: true,
      selected_field_false: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    SelectedPublish() {
      return this.items.filter(publish => publish.status == "publish");
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    getDetail(payload) {
      this.$store
        .dispatch("NewUserPromoModule/getNewUserPromo", payload)
        .then(response => {
          this.detail = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("status", "publish");
      formData.append("status", "archive");
      this.$store
        .dispatch("NewUserPromoModule/getNewUserPromos", formData)
        .then(response => {
          // let arr = response.data.data.map(data => {
          //   let article = JSON.parse(data.results);
          //   return {
          //     content: article.content.id,
          //     title: article.title.id,
          //     category: article.category
          //   };
          // });
          // vm.items = arr;
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.items = response.data.data.results;
        })
        .catch(error => {
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("NewUserPromoModule/delNewUserPromo", id);
          this.$refs.selectableTable.refresh();
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },
    onRowSelected(items) {
      this.selected = items;
    },
    submitStatus(status) {
      const formData = new FormData();
      $.each(this.selected, (key, value) => {
        formData.append("new_user_promo_id", value.id);
        formData.append("status", status);
      });
      // $.each(formData.getAll("new_user_promo_id"), function(key, value) {
      //   console.log(value);
      // });
      this.loading = true;
      this.$store
        .dispatch("NewUserPromoModule/updateStatusNewUserPromos", formData)
        .then(response => {
          this.loading = false;
          this.$refs.selectableTable.refresh();
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1000
          });
          console.log(response);
        })
        .catch(error => {
          this.loading = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          console.log(error);
        });
    },
    toggleAll(checked) {
      this.selected = checked
        ? this.$refs.selectableTable.selectAllRows()
        : this.$refs.selectableTable.clearSelected();
    }
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newVal.length === this.items.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    }
  }
};
</script>

<style>
</style>
